import { render, staticRenderFns } from "./ResultadosC3Section.vue?vue&type=template&id=343c6678"
import script from "./ResultadosC3Section.vue?vue&type=script&lang=js"
export * from "./ResultadosC3Section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports